import { t } from '../i18n';
import { IDataConvertLinkProduct, ILinkProduct } from '../types';
import { getProductUrl } from '@teko/discovery';
import { CartItem } from '@teko/cart/v2';
import { getCookieOver18YearOld } from '@teko/utils';

export const getComboImageUrl = (childItems: CartItem[]): string[] => {
  if (childItems.length === 0) return [];
  return childItems.map((item) => item.imageUrl || '');
};

export const needConfirm18YearsOld = (
  isAlcoholicCategory: boolean,
): boolean => {
  const isOver18YearsOld = getCookieOver18YearOld();
  return !isOver18YearsOld && isAlcoholicCategory;
};

const getMaxProductQuantity = (item: CartItem) =>
  item.available || Number.MAX_SAFE_INTEGER;

const getMaxComboQuantity = (item: CartItem, itemMaximumQuantity: number) =>
  // currently Cart Service only support int combo quantity
  Math.floor(
    item.childItems.reduce((maxQuantity, { quantity, available }) => {
      if (available != null)
        return Math.min((available / quantity) * item.quantity, maxQuantity);
    }, itemMaximumQuantity),
  );

export const getItemMaxQuantity = (
  item: CartItem,
  itemMaximumQuantity: number,
) => {
  const isCombo = item.childItems.length > 0;
  return isCombo
    ? getMaxComboQuantity(item, itemMaximumQuantity)
    : getMaxProductQuantity(item);
};

/**
 * return cart title base on orderId and isClone properties
 * @param orderId
 * @param isClone
 * @returns
 */
export const getCartTitle = (orderId: string, isClone: boolean): string => {
  // case checkout new order
  if (!orderId) {
    return t('Giỏ hàng');
  }

  // case clone order
  if (isClone) {
    return t(`Giỏ hàng (copy đơn {{orderId}})`, { orderId });
  }

  // case edit order
  return t(`Sửa đơn hàng {{orderId}}`, { orderId });
};

export const getLinkProduct = ({
  name,
  sku,
}: IDataConvertLinkProduct): ILinkProduct => {
  return {
    as: getProductUrl(name, sku),
    href: { pathname: '/products/[sku]', query: { sku: sku } },
    passHref: true,
  };
};
